export default __webpack_public_path__ + "static/media/honda-right-side-view2.72a9d1b0.jpg";